'use client';
import React, { useMemo } from 'react';
import Link from 'next/link';
import AppImage from '@/components/ui/AppImage';
import { Heart, MapPin, Star, Users, Clock, ChevronLeft, ChevronRight } from 'lucide-react';
import { useState } from 'react';
import type { VenueFilters } from './VenueListingContent';

// Backend integration point: replace with API call to /api/venues
const allVenues = [
{ id: 'venue-001', name: 'The Grand Meridian', location: 'Bandra West, Mumbai', city: 'Mumbai', type: 'Wedding', rating: 4.9, reviews: 312, capacity: 800, priceHourly: 15000, priceFullDay: 95000, image: "https://img.rocket.new/generatedImages/rocket_gen_img_1002e08ff-1772253453961.png", alt: 'Grand ballroom with golden chandeliers and white floral arrangements for wedding', tag: 'Most Booked', amenities: ['Catering', 'Parking', 'AV Setup', 'Decor'], available: true },
{ id: 'venue-002', name: 'Skyline Terrace', location: 'Connaught Place, Delhi', city: 'Delhi', type: 'Corporate', rating: 4.7, reviews: 184, capacity: 200, priceHourly: 8000, priceFullDay: 48000, image: "https://img.rocket.new/generatedImages/rocket_gen_img_1f1a939a2-1766760947149.png", alt: 'Modern rooftop terrace with city skyline view and minimalist event setup', tag: 'New', amenities: ['WiFi', 'AV Setup', 'Catering', 'Parking'], available: true },
{ id: 'venue-003', name: 'Emerald Gardens', location: 'Whitefield, Bangalore', city: 'Bangalore', type: 'Reception', rating: 4.8, reviews: 256, capacity: 500, priceHourly: 12000, priceFullDay: 72000, image: "https://images.unsplash.com/photo-1696178002041-5508192f675a", alt: 'Lush garden venue with fairy lights and floral arches for outdoor reception', tag: 'Top Rated', amenities: ['Garden', 'Catering', 'Parking', 'Decor'], available: true },
{ id: 'venue-004', name: 'Crystal Pavilion', location: 'Jubilee Hills, Hyderabad', city: 'Hyderabad', type: 'Wedding', rating: 4.6, reviews: 198, capacity: 600, priceHourly: 18000, priceFullDay: 110000, image: "https://images.unsplash.com/photo-1574660146489-bc8e6b1ff34d", alt: 'Crystal-adorned wedding pavilion with dramatic uplighting and ornate stage', tag: 'Premium', amenities: ['Catering', 'Valet', 'Stage', 'AV Setup'], available: false },
{ id: 'venue-005', name: 'The Blue Lagoon', location: 'Koregaon Park, Pune', city: 'Pune', type: 'Birthday', rating: 4.5, reviews: 143, capacity: 150, priceHourly: 5000, priceFullDay: 30000, image: "https://images.unsplash.com/photo-1719224485013-ee3a9701eae7", alt: 'Vibrant indoor party hall with colorful lighting and spacious dance floor', tag: 'Budget Pick', amenities: ['DJ', 'Bar', 'Catering', 'Parking'], available: true },
{ id: 'venue-006', name: 'Heritage Haveli', location: 'Civil Lines, Jaipur', city: 'Jaipur', type: 'Wedding', rating: 4.9, reviews: 421, capacity: 1000, priceHourly: 25000, priceFullDay: 150000, image: "https://img.rocket.new/generatedImages/rocket_gen_img_1a0d261bd-1766896152808.png", alt: 'Traditional Rajasthani haveli with carved arches and vibrant courtyard for weddings', tag: 'Heritage', amenities: ['Heritage', 'Catering', 'Valet', 'Decor'], available: true },
{ id: 'venue-007', name: 'The Lotus Convention', location: 'Viman Nagar, Pune', city: 'Pune', type: 'Conference', rating: 4.4, reviews: 89, capacity: 300, priceHourly: 10000, priceFullDay: 60000, image: "https://img.rocket.new/generatedImages/rocket_gen_img_102e3e41e-1773166798568.png", alt: 'Professional convention center with tiered seating and large projection screen', tag: null, amenities: ['WiFi', 'AV Setup', 'Catering', 'Parking'], available: true },
{ id: 'venue-008', name: 'Royal Orchid Banquet', location: 'Indiranagar, Bangalore', city: 'Bangalore', type: 'Wedding', rating: 4.7, reviews: 302, capacity: 700, priceHourly: 20000, priceFullDay: 120000, image: "https://img.rocket.new/generatedImages/rocket_gen_img_1cd006c4e-1772860716046.png", alt: 'Royal banquet hall with orchid floral decor and golden ceiling for weddings', tag: 'Top Rated', amenities: ['Catering', 'Parking', 'Stage', 'Decor', 'Valet'], available: true },
{ id: 'venue-009', name: 'Serenity Lawns', location: 'Powai, Mumbai', city: 'Mumbai', type: 'Reception', rating: 4.6, reviews: 167, capacity: 400, priceHourly: 14000, priceFullDay: 85000, image: "https://img.rocket.new/generatedImages/rocket_gen_img_192d7181c-1772256313091.png", alt: 'Open-air lawn venue with string lights and white tent canopy for evening reception', tag: null, amenities: ['Garden', 'Catering', 'Parking', 'Decor'], available: true },
{ id: 'venue-010', name: 'The Park Regency', location: 'Park Street, Kolkata', city: 'Kolkata', type: 'Birthday', rating: 4.3, reviews: 112, capacity: 250, priceHourly: 7000, priceFullDay: 42000, image: "https://images.unsplash.com/photo-1645193739430-13fa750adb4b", alt: 'Elegant birthday party venue with balloon arch and themed table setups', tag: null, amenities: ['DJ', 'Catering', 'Bar', 'Parking'], available: true },
{ id: 'venue-011', name: 'Ananda Mahal', location: 'Anna Nagar, Chennai', city: 'Chennai', type: 'Wedding', rating: 4.8, reviews: 289, capacity: 900, priceHourly: 22000, priceFullDay: 130000, image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d421fc01-1772259150430.png", alt: 'South Indian style wedding hall with traditional mandap and floral rangoli', tag: 'Heritage', amenities: ['Catering', 'Parking', 'Stage', 'Decor', 'Valet'], available: false },
{ id: 'venue-012', name: 'Horizon Business Centre', location: 'Cyber City, Gurugram', city: 'Gurugram', type: 'Corporate', rating: 4.5, reviews: 78, capacity: 180, priceHourly: 9000, priceFullDay: 55000, image: "https://img.rocket.new/generatedImages/rocket_gen_img_1062dd4cb-1767322335983.png", alt: 'Contemporary corporate event space with floor-to-ceiling windows and modular seating', tag: null, amenities: ['WiFi', 'AV Setup', 'Catering', 'Parking'], available: true }];


const ITEMS_PER_PAGE = 9;

type Props = {
  filters: VenueFilters;
  sortBy: string;
  searchQuery: string;
  currentPage: number;
  setCurrentPage: (p: number) => void;
};

export default function VenueGrid({ filters, sortBy, searchQuery, currentPage, setCurrentPage }: Props) {
  const [wishlisted, setWishlisted] = useState<Set<string>>(new Set());

  const toggleWishlist = (id: string) => {
    setWishlisted((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);else
      next.add(id);
      return next;
    });
  };

  const filtered = useMemo(() => {
    let result = [...allVenues];

    if (searchQuery) {
      const q = searchQuery.toLowerCase();
      result = result.filter((v) => v.name.toLowerCase().includes(q) || v.location.toLowerCase().includes(q));
    }
    if (filters.eventTypes.length) {
      result = result.filter((v) => filters.eventTypes.includes(v.type));
    }
    if (filters.priceMax < 300000) {
      result = result.filter((v) => v.priceFullDay <= filters.priceMax);
    }
    if (filters.capacityMin > 0) {
      result = result.filter((v) => v.capacity >= filters.capacityMin);
    }
    if (filters.rating > 0) {
      result = result.filter((v) => v.rating >= filters.rating);
    }
    if (filters.availability === 'available') {
      result = result.filter((v) => v.available);
    }
    if (filters.amenities.length) {
      result = result.filter((v) => filters.amenities.every((a) => v.amenities.includes(a)));
    }

    result.sort((a, b) => {
      if (sortBy === 'price-asc') return a.priceFullDay - b.priceFullDay;
      if (sortBy === 'price-desc') return b.priceFullDay - a.priceFullDay;
      if (sortBy === 'rating') return b.rating - a.rating;
      if (sortBy === 'capacity') return b.capacity - a.capacity;
      if (sortBy === 'newest') return b.reviews - a.reviews;
      return b.reviews - a.reviews;
    });

    return result;
  }, [filters, sortBy, searchQuery]);

  const totalPages = Math.ceil(filtered.length / ITEMS_PER_PAGE);
  const paginated = filtered.slice((currentPage - 1) * ITEMS_PER_PAGE, currentPage * ITEMS_PER_PAGE);

  if (filtered.length === 0) {
    return (
      <div className="bg-white rounded-2xl border border-gray-100 shadow-card p-16 text-center">
        <div className="w-16 h-16 bg-red-50 rounded-2xl flex items-center justify-center mx-auto mb-4">
          <MapPin size={28} className="text-red-400" />
        </div>
        <h3 className="font-bold text-gray-900 text-xl mb-2">No venues match your filters</h3>
        <p className="text-gray-500 text-sm max-w-sm mx-auto">
          Try adjusting your filters — widen the price range, lower the minimum capacity, or remove some amenity requirements.
        </p>
      </div>);

  }

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <p className="text-sm text-gray-600 font-medium">
          <span className="font-bold text-gray-900 font-tabular">{filtered.length}</span> venues found
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5">
        {paginated.map((venue) =>
        <article key={venue.id} className="bg-white rounded-2xl border border-gray-100 overflow-hidden card-hover shadow-card group">
            <div className="relative aspect-[16/10] overflow-hidden">
              <AppImage
              src={venue.image}
              alt={venue.alt}
              fill
              className="object-cover group-hover:scale-105 transition-transform duration-500" />
            
              {venue.tag &&
            <div className={`absolute top-3 left-3 text-white text-xs font-bold px-2.5 py-1 rounded-full ${
            venue.tag === 'Most Booked' ? 'bg-red-600' :
            venue.tag === 'Top Rated' ? 'bg-yellow-600' :
            venue.tag === 'New' ? 'bg-green-600' :
            venue.tag === 'Premium' ? 'bg-purple-600' :
            venue.tag === 'Heritage' ? 'bg-amber-600' : 'bg-blue-600'}`
            }>
                  {venue.tag}
                </div>
            }
              <div className={`absolute top-3 right-12 text-xs font-semibold px-2.5 py-1 rounded-full ${
            venue.available ? 'badge-available' : 'badge-booked'}`
            }>
                {venue.available ? 'Available' : 'Booked'}
              </div>
              <button
              onClick={() => toggleWishlist(venue.id)}
              className="absolute top-3 right-3 w-8 h-8 bg-white/90 hover:bg-white rounded-full flex items-center justify-center shadow-sm transition-all active:scale-90"
              aria-label={`${wishlisted.has(venue.id) ? 'Remove from' : 'Add to'} wishlist`}>
              
                <Heart size={15} className={wishlisted.has(venue.id) ? 'fill-red-500 text-red-500' : 'text-gray-500'} />
              </button>
            </div>

            <div className="p-4">
              <div className="flex items-start justify-between gap-2 mb-1.5">
                <h3 className="font-bold text-gray-900 text-base leading-tight">{venue.name}</h3>
                <div className="flex items-center gap-1 shrink-0">
                  <Star size={13} className="fill-yellow-400 text-yellow-400" />
                  <span className="text-sm font-bold text-gray-900 font-tabular">{venue.rating}</span>
                </div>
              </div>

              <div className="flex items-center gap-1 text-gray-500 text-xs mb-3">
                <MapPin size={11} className="text-red-400 shrink-0" />
                <span className="truncate">{venue.location}</span>
              </div>

              <div className="flex items-center justify-between text-xs text-gray-500 mb-3">
                <div className="flex items-center gap-1">
                  <Users size={11} />
                  <span>Up to {venue.capacity.toLocaleString('en-IN', { useGrouping: true })}</span>
                </div>
                <div className="flex items-center gap-1">
                  <Clock size={11} />
                  <span>₹{(venue.priceHourly / 1000).toFixed(0)}K/hr</span>
                </div>
                <span className="bg-gray-50 border border-gray-100 text-gray-600 px-2 py-0.5 rounded-full text-xs font-medium">{venue.type}</span>
              </div>

              <div className="flex items-center justify-between pt-3 border-t border-gray-50">
                <div className="text-red-600 font-extrabold text-lg font-tabular">
                  ₹{(venue.priceFullDay / 1000).toFixed(0)}K
                  <span className="text-xs text-gray-400 font-normal ml-1">/ full day</span>
                </div>
                <Link
                href="/venue-details-page"
                className="text-xs font-bold text-red-600 border-2 border-red-600 px-3 py-1.5 rounded-lg hover:bg-red-600 hover:text-white transition-all active:scale-95">
                
                  View Details
                </Link>
              </div>
            </div>
          </article>
        )}
      </div>

      {/* Pagination */}
      {totalPages > 1 &&
      <div className="flex items-center justify-between mt-8 bg-white rounded-2xl border border-gray-100 shadow-card px-5 py-3">
          <p className="text-sm text-gray-500">
            Page <span className="font-bold text-gray-900">{currentPage}</span> of <span className="font-bold">{totalPages}</span>
          </p>
          <div className="flex items-center gap-1.5">
            <button
            onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
            disabled={currentPage === 1}
            className="w-8 h-8 rounded-lg border border-gray-200 flex items-center justify-center hover:border-red-400 hover:text-red-600 disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
            
              <ChevronLeft size={15} />
            </button>
            {Array.from({ length: totalPages }).map((_, i) =>
          <button
            key={`page-${i + 1}`}
            onClick={() => setCurrentPage(i + 1)}
            className={`w-8 h-8 rounded-lg text-sm font-bold transition-all ${
            currentPage === i + 1 ?
            'bg-red-600 text-white' : 'border border-gray-200 text-gray-700 hover:border-red-400 hover:text-red-600'}`
            }>
            
                {i + 1}
              </button>
          )}
            <button
            onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}
            disabled={currentPage === totalPages}
            className="w-8 h-8 rounded-lg border border-gray-200 flex items-center justify-center hover:border-red-400 hover:text-red-600 disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
            
              <ChevronRight size={15} />
            </button>
          </div>
        </div>
      }
    </div>);

}